import * as React from 'react';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import LaborSettings, { LaborSettingsHint } from 'ab-enums/laborSettings.enum';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

interface OwnProps {
	company: CompanyViewModel;
	toggleEdit: () => void;
}

type Props = OwnProps;

class EmployeeStatusSettingsPreview extends React.PureComponent<Props> {

	render() {
		const { toggleEdit, company } = this.props;
		const { isEmployeeAutomaticReturnDate } = company;

		return (
			<SettingPreview toggleEdit={toggleEdit}>
				<div className="company-settings__info-segment">
					<PreviewItem
						checked={isEmployeeAutomaticReturnDate}
						hint={LaborSettingsHint.isEmployeeAutomaticReturnDate}
						indent={false}
						label={LaborSettings.isEmployeeAutomaticReturnDate}
						showCheckbox={true}
					/>
				</div>
			</SettingPreview>
		);
	}
}

export default EmployeeStatusSettingsPreview;
